import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import { Contractor } from 'api';
import { useFetchContractorDirectory } from 'hooks';

function useProfileQueryByEmail(
  contractorEmail: string,
  options?: UseQueryOptions<Contractor, Error>,
): UseQueryResult<Contractor, Error> {
  const authorisedFetch = useFetchContractorDirectory();

  return useQuery<Contractor, Error>(
    ['profile', contractorEmail],
    async () => {
      const response = await authorisedFetch(`/contractors/${contractorEmail}`, {
        method: 'GET',
      });

      return await response.json();
    },
    options,
  );
}

export default useProfileQueryByEmail;
